/**
 * Conta de cubagem das caixas.
 *
 * A transportadora cobra pelo maior valor entre o peso real e o peso cubado —
 * o volume convertido em quilo pelo divisor do modal aereo. FedEx e UPS usam
 * 5000 para cm/kg no internacional, que e o caso de todo envio da Intrex.
 */
export const DIVISOR_CUBAGEM = 5000;

/** Volume em litros. cm3 / 1000. */
export const volumeLitros = (
  comprimento: number,
  largura: number,
  altura: number,
) => (comprimento * largura * altura) / 1000;

/** Peso cubado em kg. */
export const pesoCubado = (
  comprimento: number,
  largura: number,
  altura: number,
) => (comprimento * largura * altura) / DIVISOR_CUBAGEM;

/**
 * Numero com casas fixas no idioma da tela. Mantem a virgula decimal em
 * portugues e espanhol e o ponto em ingles, em vez de fixar pt-BR na mao.
 */
export const formatarNumero = (
  valor: number,
  casas: number,
  locale = "pt-BR",
) =>
  Number.isFinite(valor)
    ? valor.toLocaleString(locale, {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas,
      })
    : "—";

/** "30 × 20 × 15 cm" — a ordem do cabecalho da tabela (C × L × A). */
export const formatarMedidas = (
  comprimento: number,
  largura: number,
  altura: number,
  locale = "pt-BR",
) => {
  const medida = (v: number) =>
    v.toLocaleString(locale, { maximumFractionDigits: 1 });
  return `${medida(comprimento)} × ${medida(largura)} × ${medida(altura)} cm`;
};
